(function() {
    "use strict";

    angular.module('eSign')
        .service('signTaskService', ['$http', 'appConfig', function($http, appConfig) {

            this.getUploadDocumentURL = function() {
              return appConfig.baseUrl + '/UploadDocument';
            };

            this.getCombinedDocumentURL = function() {
              return appConfig.baseUrl + '/GetCombinedDocument';
            };
            
            this.getSignedDocumentURL = function (reference, signTaskId) {
                var stId = (typeof signTaskId !== 'undefined') ? signTaskId : '';
                return appConfig.baseUrl + '/showsigneddocument?documentReference=' + reference + '&stId=' + stId;
                //return $http.post(appConfig.baseUrl + '/GetDocument', { reference: reference });
            };

            // Signtasks
            this.getActiveSignTasks = function() {
              return $http.get(appConfig.baseUrl + '/GetActiveSignTasks');
			};

		    this.getSignTaskNotReadyToSign = function () {
				return $http.get(appConfig.baseUrl + '/GetSignTaskNotReadyToSign');
		    };

            this.rejectSignTask = function (applicationNumber) {
                return $http.post(appConfig.baseUrl + '/RejectSignTask', { applicationNumber: applicationNumber });
            };

            this.setUploadDocumentStepComplete = function(deferUpload) {
              return $http.post(appConfig.baseUrl + '/SetUploadDocumentStepComplete', { deferUpload: deferUpload });
            };

            this.getRequiredUploadsForCurrentSignTask = function() {
              return $http.get(appConfig.baseUrl + '/GetRequiredUploadsForCurrentSignTask');
            };

            this.getExternalReference = function () {
                return $http.get(appConfig.baseUrl + '/GetExternalReference');
            };

            this.getInsuranceForSignTask = function () {
                return $http.get(appConfig.baseUrl + '/GetInsuranceForSignTask');
            };

            this.setInsuranceStepComplete = function (insuranceAccepted, insuranceCode, insuranceCompany) {
                return $http.post(appConfig.baseUrl + '/SetInsuranceStepCompleted', {insuranceAccepted: insuranceAccepted, insuranceCode: insuranceCode, insuranceCompany: insuranceCompany});
            };

            // Documents
            this.getShowDocumentURL = function(ref) {
              return appConfig.baseUrl + '/showdocument?documentReference=' + ref;
            };

            this.getDocumentsForSignTask = function() {
              return $http.get(appConfig.baseUrl + '/GetDocumentsForSignTask');
            };

            this.getCompletedDocumentsForSignTask = function (setSignTaskComplete) {
                return $http.post(appConfig.baseUrl + '/GetCompletedDocumentsForSignTask', {setSignTaskComplete: setSignTaskComplete});
            };

            // Customer info
            this.submitCustomerForm = function (values) {
                return $http.post(appConfig.baseUrl + '/SubmitCustomerForm', values);
			}

            // Aml info
            this.submitAmlForm = function (values) {
				return $http.post(appConfig.baseUrl + '/SubmitAmlForm', values);
            }

			this.getJobTitles = function () {
                return $http.get(appConfig.baseUrl + '/GetJobTitles');
            }

        }]);
}());
